import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import SocialButton from "../layout/SocialButton";
const OnWeb = () => {
  return (
    <>
      <Container maxWidth="md">
        <Grid item xs={12} sx={{ display: "flex", justifyContent: "felx-start" }}>
        <Typography
          variant="h6"
          color="white"
          sx={{  marginBottom:".5rem" }}
        >
          On the Web:
        </Typography>
        </Grid>
        <Grid item xs={12} sx={{ display: "flex", marginBottom:".25rem",  justifyContent: "felx-start" }}>
        <SocialButton link="https://github.com/Omarhussian" name="@github" />
        </Grid>
        <Grid item xs={12} sx={{ display: "flex", marginBottom:".25rem" ,  justifyContent: "felx-start" }}>
        <SocialButton link="https://www.linkedin.com/in/alhussain23/" name="@linkedin" />
        </Grid>
        <Grid item xs={12} sx={{ display: "flex", marginBottom:".25rem" ,  justifyContent: "felx-start" }}>
        <SocialButton link="https://www.facebook.com/omar.hossien.16/" name="@facebook" />
        </Grid>
        <Grid item xs={12} sx={{ display: "flex", marginBottom:".25rem" , justifyContent: "felx-start" }}>
        <SocialButton link="https://twitter.com/alhussain2323" name="@twitter" />
        </Grid>
        
      </Container>
    </>
  );
};
export default OnWeb;
